export enum DeviceMicroController {
  COBRA_DEVICE_MC = "COBRA_DEVICE_MC",
  COBRA_DEVICE_SC = "COBRA_DEVICE_SC",
  COBRA_PL_SENSOR_MC = "COBRA_PL_SENSOR_MC",
  COBRA_PL_SENSOR_SC = "COBRA_PL_SENSOR_SC",
}
